import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { ANY_SPORT_SERIES_MARKET_COMMON_PACKS as LEGACY_ANY_SPORT_MARKET_COMMON_PACKS } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

const RedirectToCommonPacksPage = () => {
  const {
    flags: { enableNavToggleProSet = false },
  } = useFeatureFlags();
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(
        enableNavToggleProSet
          ? ANY_SPORT_SERIES_MARKET
          : LEGACY_ANY_SPORT_MARKET_COMMON_PACKS
      )}
      replace
    />
  );
};
export default RedirectToCommonPacksPage;
